import ViewModel from './viewModel';
import ProfileModel from '../models/profileModel';
import AddressModel from '../models/addressModel';
import AddressConfigModel from '../models/addressConfigModel';
import Events from '../controllers/event';
import Service from '../services/services';
import { getGroupTypeByCountry } from '../../../core/js/utils/validationUtils';
import { getInitialGroupType, getSiteBySiteId } from '../helpers/helpers';
import { scrollToElement } from '../../../core/js/utils/scrollUtils';

class AddressViewModel extends ViewModel {
    constructor(ProfileModel) {
        super();
        this.viewStates = {
            newAddress: false,
            newAddressInPaymentForm: false,
            newPayment: false,
            editAddress: false,
            tempAddress: false,
            editPayment: false,
            tempPayment: false,
            deleteAddressModal: false,
            deletePaymentModal: false,
            qasModal: false,
            orphanPayments: false,
            deleteSuccessModal: false,
            deletePaymentSuccess: false,
            deleteAddressSuccess: false,
            qasPartialAddressSelected: false,
            showErrors: false,
            formFocus: false,
            autoComplete: false,
            autoCompleteLocale: false,
            autoCompleteSelected: false
        };
        this.events = {
            addNewAddress: {
                type: 'click',
                element: '.js-address-new',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['newAddress', 'formFocus', 'newAddressInPaymentForm', 'focusValue', 'deletePaymentSuccess', 'deleteAddressSuccess'],
                        values: [true, true, false, 'address', false, false]
                    },
                    events: {
                        names: ['addNewAddress'],
                        values: []
                    },
                    extraFunctions: ['scrollToDesktopForms', 'autoCompleteSetup', 'resetServerErrors'],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'clearSelectedCountry',
                        modelProperty: 'selectedCountry',
                        serviceMethod: '',
                        altModel: AddressConfigModel
                    }, {
                        status: true,
                        modelMethod: 'clearSelectedCountryRegions',
                        modelProperty: 'selectedCountryRegions',
                        serviceMethod: '',
                        altModel: AddressConfigModel
                    }]
                }
            },
            cancelNewAddress: {
                type: 'click',
                element: '.js-account-address-new-cancel',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['focusValue', 'autoComplete', 'newAddress', 'formFocus', 'deletePaymentSuccess', 'deleteAddressSuccess'],
                        values: ['', false, 'toggle', 'toggle', false, false]
                    },
                    events: {
                        names: ['addNewAddress'],
                        values: []
                    },
                    extraFunctions: [],
                    modelUpdate: []
                }
            },
            saveNewAddress: {
                type: 'click',
                element: '.js-account-address-new-save',
                status: true,
                rendered: false,
                sequentialModelUpdate: true,
                resetTemps: false,
                action: {
                    viewStates: {
                        names: ['focusValue', 'autoComplete', 'newAddress', 'formFocus', 'deletePaymentSuccess', 'deleteAddressSuccess'],
                        values: ['', false, 'toggle', 'toggle', false, false]
                    },
                    events: {
                        names: ['addNewAddress'],
                        values: []
                    },
                    // extraFunctions: ['errorValidation', 'coremetricsAddrRegistrationTag'],
                    extraFunctions: ['errorValidation', 'smallScreenScroll'],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'createAddress',
                        modelProperty: {
                            temp: 'temp',
                            prop: 'userAddresses'
                        },
                        serviceMethod: 'createAddress',
                        altModel: ''
                    }, {
                        status: true,
                        modelMethod: 'setDefaultAddressFromNewForm',
                        modelProperty: 'profile',
                        serviceMethod: 'updateProfile',
                        altModel: ProfileModel
                    }, {
                        status: true,
                        modelMethod: 'handleEditExit',
                        modelProperty: 'editableAddressId',
                        serviceMethod: '',
                        altModel: ''
                    }]
                }
            },
            populateFormBasedonCountry: {
                type: 'change',
                element: '.js-account-address-country-select',
                status: true,
                rendered: false,
                resetTemps: false,
                sequentialModelUpdate: true,
                action: {
                    viewStates: {
                        names: ['tempAddress', 'deletePaymentSuccess', 'deleteAddressSuccess'],
                        values: [true, false, false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: ['updateTempAddressGroupType', 'autoCompleteSetup'],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'setSelectedCountry',
                        modelProperty: 'selectedCountry',
                        serviceMethod: '',
                        altModel: ''
                    }, {
                        status: true,
                        modelMethod: 'setCountryGroupType',
                        modelProperty: 'groupType',
                        serviceMethod: '',
                        altModel: ''
                    }]
                }
            },
            showNewAddressFormOnPaymentForm: {
                type: 'change',
                element: '#billing-address-payments',
                status: true,
                rendered: false,
                resetTemps: false,
                action: {
                    viewStates: {
                        names: ['tempPayment', 'deletePaymentSuccess', 'deleteAddressSuccess'],
                        values: [true, false, false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: ['showNewAddressForm', 'autoCompleteSetup'],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'setCardTypeOnBlur',
                        modelProperty: '',
                        serviceMethod: '',
                        altModel: ''
                    }]
                }
            },
            showCardTypeOnBlur: {
                type: 'change',
                element: '.js-account-card-number-payments',
                status: true,
                rendered: false,
                resetTemps: false,
                action: {
                    viewStates: {
                        names: ['tempPayment', 'deletePaymentSuccess', 'deleteAddressSuccess'],
                        values: [true, false, false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: [],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'setCardTypeOnBlur',
                        modelProperty: '',
                        serviceMethod: '',
                        altModel: ''
                    }]
                }
            },

            validatedCreditCardYear: {
                type: 'change',
                element: '.js-account-card-expiration-month-payments, .js-account-card-expiration-year-payments',
                status: true,
                rendered: false,
                resetTemps: false,
                action: {
                    viewStates: {
                        names: ['tempPayment', 'deletePaymentSuccess', 'deleteAddressSuccess'],
                        values: [true, false, false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: ['creditCardExpiration'],
                    modelUpdate: []
                }
            },

            editAddress: {
                type: 'click',
                element: '.js-address-edit',
                status: true,
                rendered: false,
                sequentialModelUpdate: true,
                action: {
                    viewStates: {
                        names: ['focusValue', 'editAddress', 'formFocus', 'deletePaymentSuccess', 'deleteAddressSuccess', 'newAddressInPaymentForm'],
                        values: ['editAddress', 'toggle', 'toggle', false, false, false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: ['autoCompleteSetup', 'setTempGroupType'],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'handleEditAddressFocus',
                        modelProperty: 'editableAddressId',
                        serviceMethod: '',
                        altModel: ''
                    }, {
                        status: true,
                        modelMethod: 'showSelectedAddress',
                        modelProperty: '',
                        serviceMethod: '',
                        altModel: ''
                    }, {
                        status: true,
                        modelMethod: 'setCountryGroupType',
                        modelProperty: 'groupType',
                        serviceMethod: '',
                        altModel: ''
                    }, {
                        status: true,
                        modelMethod: 'clearSelectedCountry',
                        modelProperty: 'selectedCountry',
                        serviceMethod: '',
                        altModel: AddressConfigModel
                    }]
                }
            },
            editPayment: {
                type: 'click',
                element: '.js-payment-edit',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['focusValue', 'editPayment', 'formFocus', 'newAddressInPaymentForm', 'deletePaymentSuccess', 'deleteAddressSuccess'],
                        values: ['editPayment', true, true, false, false, false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: [],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'showSelectedPayment',
                        modelProperty: 'temp',
                        serviceMethod: '',
                        altModel: ''
                    }, {
                        status: true,
                        modelMethod: 'handleEditPaymentFocus',
                        modelProperty: 'editablePaymentId',
                        serviceMethod: '',
                        altModel: ''
                    }]
                }
            },
            deletePayment: {
                type: 'click',
                element: '.js-delete-payment-id',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['deletePaymentModal', 'deletePaymentSuccess', 'deleteAddressSuccess'],
                        values: [true, false, false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: [],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'showSelectedPayment',
                        modelProperty: 'temp',
                        serviceMethod: '',
                        altModel: ''
                    }]
                }
            },
            deleteAddress: {
                type: 'click',
                element: '.js-address-delete',
                status: true,
                rendered: false,
                sequentialModelUpdate: true,
                action: {
                    viewStates: {
                        names: ['deleteAddressModal', 'orphanPayments', 'deletePaymentSuccess', 'deleteAddressSuccess'],
                        values: ['toggle', 'toggle', false, false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: ['checkForOrphans'],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'showSelectedAddress',
                        modelProperty: '',
                        serviceMethod: '',
                        altModel: ''
                    }]
                }
            },
            deletePaymentConfirm: {
                type: 'click',
                element: '.js-payment-delete-confirm',
                status: true,
                rendered: false,
                sequentialModeUpdate: true,
                action: {
                    viewStates: {
                        names: ['deletePaymentModal', 'deleteSuccessModal', 'deletePaymentSuccess'],
                        values: ['toggle', 'toggle', true]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: ['showDeletedPaymentMsg'],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'deletePayment',
                        modelProperty: {
                            temp: 'tempPayment',
                            prop: 'userPayments'
                        },
                        serviceMethod: 'deletePayment',
                        altModel: ''
                    }]
                }
            },
            deletePaymentCancel: {
                type: 'click',
                element: '.js-payment-delete-cancel',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['deletePaymentModal'],
                        values: [false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: [],
                    modelUpdate: []
                }
            },
            deleteAddressCancel: {
                type: 'click',
                element: '.js-address-delete-cancel',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['deleteAddressModal', 'orphanPayments', 'deletePaymentSuccess', 'deleteAddressSuccess'],
                        values: ['toggle', 'toggle', false, false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: [],
                    modelUpdate: []
                }
            },
            deleteAddressConfirm: {
                type: 'click',
                element: '.js-address-delete-confirm',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['deleteAddressModal', 'deleteSuccessModal', 'orphanPayments', 'deleteAddressSuccess'],
                        values: ['toggle', 'toggle', 'toggle', true]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: ['showDeletedAddressMsg'],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'deleteAddress',
                        modelProperty: {
                            temp: 'temp',
                            prop: 'userAddresses'
                        },
                        serviceMethod: 'deleteAddress',
                        altModel: ''
                    }]
                }
            },
            setAddressAsDefault: {
                type: 'click',
                element: '.js-address-set-default',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: [],
                        values: []
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: [],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'setDefaultAddress',
                        modelProperty: 'profile',
                        serviceMethod: 'updateProfile',
                        altModel: ProfileModel
                    }]
                }
            },
            setPaymentAsDefault: {
                type: 'click',
                element: '.js-payment-set-default',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: [],
                        values: []
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: [],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'setDefaultPayment',
                        modelProperty: 'profile',
                        serviceMethod: 'updateProfile',
                        altModel: ProfileModel
                    }]
                }
            },
            addNewPayment: {
                type: 'click',
                element: '.js-add-new-card-payments',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['newPayment', 'formFocus', 'newAddressInPaymentForm', 'focusValue', 'deletePaymentSuccess', 'deleteAddressSuccess'],
                        values: [true, true, false, 'payment', false, false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: ['scrollToDesktopForms', 'resetServerErrors'],
                    modelUpdate: [
                        // {
                        //     status : true,
                        //     modelMethod : 'clearCCImg',
                        //     modelProperty : 'tempPayment',
                        //     serviceMethod : '',
                        //     altModel : ''
                        // }
                    ]
                }
            },
            submitNewPayment: {
                type: 'click',
                element: '.js-account-submit-new-card-payments',
                status: true,
                rendered: false,
                resetTemps: false,
                sequentialModelUpdate: true,
                action: {
                    viewStates: {
                        names: ['newPayment', 'tempPayment', 'newAddressInPaymentForm', 'focusValue', 'formFocus', 'deletePaymentSuccess', 'deleteAddressSuccess'],
                        values: [false, false, false, '', 'toggle', false, false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    // extraFunctions: ['errorValidation', 'coremetricsPaymentRegistrationTag'],
                    extraFunctions: ['errorValidation', 'updatePxpPublicKey'],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'createAddress',
                        modelProperty: {
                            temp: 'temp',
                            prop: 'userAddresses'
                        },
                        serviceMethod: 'createAddress',
                        altModel: ''
                    }, {
                        status: true,
                        modelMethod: 'setDefaultAddressFromNewForm',
                        modelProperty: 'profile',
                        serviceMethod: 'updateProfile',
                        altModel: ProfileModel
                    }, {
                        status: true,
                        modelMethod: 'submitNewPayment',
                        modelProperty: {
                            temp: 'temp',
                            prop: 'userPayments'
                        },
                        serviceMethod: 'submitNewPayment',
                        altModel: ''
                    }, {
                        status: true,
                        modelMethod: 'setDefaultPaymentFromNewForm',
                        modelProperty: 'profile',
                        serviceMethod: 'updateProfile',
                        altModel: ProfileModel
                    }, {
                        status: true,
                        modelMethod: 'handleEditExit',
                        modelProperty: 'editablePaymentId',
                        serviceMethod: '',
                        altModel: ''
                    }]
                }
            },
            saveEditAddress: {
                type: 'click',
                element: '.js-account-address-edit-save',
                status: true,
                rendered: false,
                sequentialModelUpdate: true,
                resetTemps: false,
                action: {
                    viewStates: {
                        names: ['focusValue', 'editAddress', 'formFocus', 'deletePaymentSuccess', 'deleteAddressSuccess'],
                        values: ['', 'toggle', 'toggle', false, false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: ['errorValidation', 'checkAssociatedPayments'],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'updateAddress',
                        modelProperty: {
                            temp: 'temp',
                            prop: 'userAddresses'
                        },
                        serviceMethod: 'updateAddress',
                        altModel: ''
                    }, {
                        status: true,
                        modelMethod: 'setDefaultAddressFromEditForm',
                        modelProperty: 'profile',
                        serviceMethod: 'updateProfile',
                        altModel: ProfileModel
                    }, {
                        status: true,
                        modelMethod: 'clearSelectedCountry',
                        modelProperty: 'selectedCountry',
                        serviceMethod: '',
                        altModel: AddressConfigModel
                    }, {
                        status: true,
                        modelMethod: 'handleEditExit',
                        modelProperty: 'editableAddressId',
                        serviceMethod: '',
                        altModel: ''
                    }]
                }
            },
            saveEditPayment: {
                type: 'click',
                element: '.js-account-payment-edit-save',
                status: true,
                rendered: false,
                resetTemps: false,
                action: {
                    viewStates: {
                        names: ['focusValue', 'editPayment', 'formFocus', 'deletePaymentSuccess', 'deleteAddressSuccess'],
                        values: ['', 'toggle', 'toggle', false, false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: ['errorValidation', 'resetServerErrors'],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'addAddressToOrphan',
                        modelProperty: {
                            temp: 'temp',
                            addressProp: 'userAddresses',
                            paymentProp: 'userPayments'
                        },
                        serviceMethod: '',
                        altModel: ''
                    }, {
                        status: true,
                        modelMethod: 'setDefaultPaymentFromEditForm',
                        modelProperty: 'profile',
                        serviceMethod: 'updateProfile',
                        altModel: ProfileModel
                    }, {
                        status: true,
                        modelMethod: 'handleEditExit',
                        modelProperty: 'editablePaymentId',
                        serviceMethod: '',
                        altModel: ''
                    }]
                }
            },
            cancelEditAddress: {
                type: 'click',
                element: '.js-account-address-edit-cancel',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['focusValue', 'editAddress', 'formFocus', 'deletePaymentSuccess', 'deleteAddressSuccess'],
                        values: ['', 'toggle', 'toggle', false, false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: [],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'handleEditExit',
                        modelProperty: 'editableAddressId',
                        serviceMethod: '',
                        altModel: ''
                    }]
                }
            },
            cancelNewPayment: {
                type: 'click',
                element: '.js-account-cancel-new-payments',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['focusValue', 'newPayment', 'formFocus', 'deletePaymentSuccess', 'deleteAddressSuccess'],
                        values: ['', 'toggle', 'toggle', false, false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: [],
                    modelUpdate: []
                }
            },
            cancelEditPayment: {
                type: 'click',
                element: '.js-account-cancel-edit-payments',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['focusValue', 'editPayment', 'formFocus', 'deletePaymentSuccess', 'deleteAddressSuccess'],
                        values: ['', 'toggle', 'toggle', false, false]
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: [],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'handleEditExit',
                        modelProperty: 'editablePaymentId',
                        serviceMethod: '',
                        altModel: ''
                    }]
                }
            },
            routeToNavLink: {
                type: 'click',
                element: '.js-account-nav li a[data-link-name="account-settings"], .js-account-navigation a[data-link-name="dashboard"]',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: [],
                        values: []
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: ['routeToLink'],
                    modelUpdate: []
                }
            },
            closeModal: {
                type: 'click',
                element: '.js-account-close-modal, .close-icon',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['qasModal', 'formFocus'],
                        values: []
                    },
                    events: {
                        names: ['closeModal'],
                        values: []
                    },
                    extraFunctions: ['closeModal'],
                    modelUpdate: []
                }
            },
            selectQASAddress: {
                type: 'click',
                element: '.js-account-select-qas-address',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['newAddress', 'qasModal'],
                        values: []
                    },
                    events: {
                        names: ['addNewAddress'],
                        values: []
                    },
                    extraFunctions: [],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'createQASAddress',
                        modelProperty: {
                            temp: 'temp',
                            prop: 'userAddresses'
                        },
                        serviceMethod: 'createAddress',
                        altModel: ''
                    }]
                }
            },
            selectEnteredAddress: {
                type: 'click',
                element: '.js-account-select-entered-address',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['newAddress', 'qasModal'],
                        values: []
                    },
                    events: {
                        names: ['addNewAddress'],
                        values: []
                    },
                    extraFunctions: [],
                    modelUpdate: [{
                        status: true,
                        modelMethod: 'createAddress',
                        modelProperty: {
                            temp: 'temp',
                            prop: 'userAddresses'
                        },
                        serviceMethod: 'createAddress',
                        altModel: ''
                    }]
                }
            },
            selectPartialAddress: {
                type: 'change',
                element: '.js-account-select-partial-address',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: ['qasPartialAddressSelected'],
                        values: []
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: [],
                    modelUpdate: []
                }
            },
            qasSubmitNumber: {
                type: 'click',
                element: '.js-account-submit-house-number',
                status: true,
                rendered: false,
                action: {
                    viewStates: {
                        names: [],
                        values: []
                    },
                    events: {
                        names: [],
                        values: []
                    },
                    extraFunctions: [],
                    modelUpdate: []
                }
            }
        };
    }
    run(functionName) {
        return this[functionName](selector);
    }

    closeModal(selector, model) {
        this.temp = {};
        const $addressFormInputs = jQuery('.js-address-edit-form').find('.js-address-form-item');
        $addressFormInputs.each(function(index) {
            const $this = jQuery(this);
            const parts = $this.attr('name');
            const value = $this.val();
            model.recursiveData(parts, value, model.temp, model);
        });
        model.temp.id = undefined;
        return Promise.resolve(this);
    }

    /**
     * A method that checks if there are any errors on an input of a form.
     * Checks to see if id is equal to billing-address-payments, if so,
     * and error location is equal to payment-edit-form, set showErrors to true.
     * Next if block checks for pseudo class :invalid via checkValidity API,
     * else, custom error event for creditCard number input.
     * @param {Object} selector
     * @param {Object} model
     */
    errorValidation(selector, model) {
        return new Promise((resolve, reject) => {
            const form = jQuery(selector).parents('form');

            AddressModel.saveTemps(model, selector);

            if (jQuery(selector).attr('id') === 'billing-address-payments') {
                if (model.errors.location === 'payment-edit-form') {
                    super.updateViewState('showErrors', true);
                } else {
                    super.updateViewState('showErrors', false);
                }

                return resolve(selector);
            }

            if (jQuery(form)[0].checkValidity() === false) {
                this.attachErrorLocation(selector)
                    .then(model => {
                        super.updateViewState('showErrors', true);
                    })
                    .then(vs => {
                        return reject({
                            type: 'validationError',
                            status: '',
                            data: {}
                        });
                    });
            } else if (jQuery('.js-address-edit-form')[0] !== undefined && jQuery('.js-address-edit-form')[0].checkValidity() === false) {
                jQuery(form)
                    .find(':invalid')
                    .each(function(index, node) {
                        console.log(node.validationMessage);
                    });
                this.attachErrorLocation(selector)
                    .then(model => {
                        super.updateViewState('showErrors', true);
                    })
                    .then(vs => {
                        return reject({
                            type: 'validationError',
                            status: '',
                            data: {}
                        });
                    });
            } else {
                if (AddressModel.detectCardType(jQuery(form).find('.js-account-card-number-payments').val()) === undefined && this.viewStates.newPayment === true) {
                    model.errors.location = 'js-creditcard-input-error';
                    super.updateViewState('showErrors', true);
                    return reject({
                        type: 'validationError',
                        status: '',
                        data: {}
                    });
                } else {
                    super.updateViewState('showErrors', false);
                    resolve(selector);
                }
            }
        });
    }

    /**
     * Change the url hash to the selector's data-link-name attribute value, and then change the route. Necessary for internal links within the app
     * @param {string} selector - DOM element
     * @returns {promise}
     */
    routeToLink(selector, model, session, store) {
        return super.updatePushState(selector, store);
    }

    /**
     * Display a modal with deleted address confirmation message in the location where the address
     * lived in the list. Determine the location by checking whether the selector's parent's sibling is
     * another address and assign deletedItem properties accordingly
     * @param {string} selector - DOM element
     */
    showDeletedAddressMsg(selector) {
        const $prevParent = jQuery(selector).parents('.js-address-payments-container').prev();
        const isNotTheFirst = $prevParent.hasClass('js-address-payments-container');
        let $addrDeleteLink;
        let deletedItemSiblingId = "";

        if (isNotTheFirst) {
            $addrDeleteLink = $prevParent.find('.js-address-delete');
            deletedItemSiblingId = $addrDeleteLink.attr('data-address-id');
        }

        const deletedItem = {
            "siblingId": deletedItemSiblingId,
            "isFirst": !isNotTheFirst
        };
        return Promise.resolve(AddressModel.setData(deletedItem, 'deletedAddress', false));
    }

    /**
     * Display a modal with deleted payment confirmation message in the location where the payment
     * lived in the list. Determine the location by checking whether the selector's parent's sibling is
     * another payment and assign deletedItem properties accordingly
     * @param {string} selector - DOM element
     */
    showDeletedPaymentMsg(selector) {
        const $prevParent = jQuery(selector).parents('.js-single-payment-item').prev();
        const isNotTheFirst = $prevParent.hasClass('js-single-payment-item');
        const selectorAddressId = jQuery(selector).attr('data-address-id');
        let $paymentDeleteLink;
        let deletedItemSiblingId = "";

        if (isNotTheFirst) {
            $paymentDeleteLink = $prevParent.find('.js-delete-payment-id');
            deletedItemSiblingId = $paymentDeleteLink.attr('data-payment-id');
        }

        const deletedItem = {
            "siblingId": deletedItemSiblingId,
            "isFirst": !isNotTheFirst,
            "selectorAddressId": selectorAddressId
        };
        return Promise.resolve(AddressModel.setData(deletedItem, 'deletedPayment', false));
    }

    /**
     * Show an empty form for a new address to be associated with a payment
     * @param {string} selector - DOM element
     */
    showNewAddressForm(selector) {
        return new Promise((resolve, reject) => {
            const formValue = jQuery(selector).val();
            const optionText = jQuery('#billing-address-payments option[value="' + formValue + '"]').text();

            console.log(ProfileModel);
            console.log(ViewModel);

            Promise.resolve(AddressModel.setData(formValue, 'selectedBillingAddress', true))
                .then(data => {
                    if (formValue === "new-address") {
                        return super.updateViewState('newAddressInPaymentForm', true);
                    } else {
                        return super.updateViewState('newAddressInPaymentForm', false);
                    }
                })
                .then(viewstate => {
                    resolve(optionText);
                });
        });

    }

    /**
     * Filter out payments that have no associated address
     * @param {string} selector - DOM element
     */
    checkForOrphans(selector) {
        console.log('checking for orphans');
        const currentAddressId = jQuery(selector).attr('data-address-id');
        const orphanPayments = AddressModel.userPayments.filter(payment => {
            let noAddressFound = false;
            if (currentAddressId === payment.creditCardDetail.addressId) {
                noAddressFound = true;
            }
            return noAddressFound;
        });
        return Promise.resolve(AddressModel.setData(orphanPayments, 'tempOrphans', true));
    }

    /**
     * If a user unchecks an associated payment in an edit address form, disassociate that payment with that address
     * and create a new address that that unchecked payment is associated with
     * @param {string} selector - DOM element
     * @param {Object} model - Address model
     * @param {string} session - Auth session
     */
    checkAssociatedPayments(selector, model, session) {
        const totalPayments = jQuery(selector).parents('form').find('.js-associated-payment');
        const selectedPayments = jQuery(selector).parents('form').find('.js-associated-payment:checked');
        if (totalPayments.length === selectedPayments.length) {
            return Promise.resolve(true);
        } else {
            // return new Promise((resolve,reject)=>{
            return new Promise((resolve, reject) => {
                model.createAddress(model, selector, {
                    temp: 'temp',
                    prop: 'userAddresses'
                }, session, 'createAddress', this)
                .then(address => {
                    // Promise.all with the array of payments to be updated
                    if (selectedPayments.length > 0) {
                        let promiseAllArray = [];
                        selectedPayments.each(function(index) {
                            const $this = jQuery(this);
                            promiseAllArray.push(model.updatePaymentsAddress($this, address, session));
                        });
                        promiseAllArray.push(Promise.resolve(address));
                        return Promise.all(promiseAllArray);
                    } else {
                        return Promise.resolve(address);
                    }
                })
                .then(payments => {
                    return ProfileModel.setDefaultFromPaymentsInEditForm(payments, selector, session);
                })
                .then(defaults => {
                    super.updateViewState('editAddress', false);
                    super.updateViewState('formFocus', false);
                    return reject({
                        type: 'altWorkflow'
                    });
                })
                .catch(error => {
                    return reject(error);
                });
            });
        }
    }

    /**
     * Scroll to the bottom of the payment list, where the new/edit form begins
     */
    scrollToDesktopForms(selector, model, session, store) {
        // leaving these commented out for now so we can revisit in the future per Chelsea's comments
        // if (!store.core.deviceCharacteristics.is_mobile && jQuery('.js-address-payments-container').length) {
        //     const headerHeight = jQuery('.js-global-header-wrap').height();
        //     jQuery('html, body').animate({
        //         scrollTop: selector.offset().top - headerHeight
        //     }, 'slow');
        // }
        return Promise.resolve(true);
    }

    /**
     * Scroll user back to top of address container on small screen
     */
    smallScreenScroll(selector, model, session, store) {
        if (store.core.deviceCharacteristics.is_smallish) {
            scrollToElement('.js-address-payments-container')
        }
        return Promise.resolve(true);
    }

    attachErrorLocation(selector) {
        if (this.viewStates.newAddressInPaymentForm) {
            return AddressModel.attachErrorLocation('payment-and-address');
        } else {
            return AddressModel.attachErrorLocation(selector);
        }
    }

    /**
     * Fire a CoreMetrics Registration Tag by calling the builtin CM function
     * cmCreateRegistrationTag with email, city, country, and postal code params
     * gathered from the address form
     */
    // coremetricsAddrRegistrationTag() {
    //     const city = jQuery("input[data-cm-element='city']").val();
    //     const postalCode = jQuery("input[data-cm-element='postal-code']").val();
    //     const country = jQuery("select[data-cm-element='country']").val();
    //     let emailAddr = ProfileModel.profile.emailAddress;
    //
    //     // if(typeof utag != 'undefined') {
    //     //       Promise.resolve(cmCreateRegistrationTag(null, emailAddr, city, country, postalCode));
    //     // }
    //     // else {
    //     //       Promise.resolve(true);
    //     // }
    //     Promise.resolve(true);
    // }

    /**
     * Fire a CoreMetrics Registration Tag by calling the builtin CMfunction cmCreateRegistrationTag
     * with email, city, country, and postal code params gathered from the address form if a user
     * adds a new address with a payment, otherwise from the corresponding payment address
     */
    // coremetricsPaymentRegistrationTag() {
    //
    //     const emailAddr = ProfileModel.profile.emailAddress;
    //     const addAddressIsSelected = jQuery('.js-address-edit-form').length > 0;
    //     let city;
    //     let postalCode;
    //     let country;
    //
    //     if (addAddressIsSelected) {
    //         city = jQuery("input[data-cm-element='city']").val();
    //         postalCode = jQuery("input[data-cm-element='postal-code']").val();
    //         country = jQuery("select[data-cm-element='country']").val();
    //
    //     } else {
    //         AddressModel.userAddresses.forEach((address) => {
    //             if (address.id === AddressModel.selectedBillingAddress) {
    //                 city = address.address.city;
    //                 postalCode = address.address.postalCode;
    //                 country = address.address.country;
    //             }
    //         });
    //     }
    //
    //     // if(typeof utag != 'undefined') {
    //     //       Promise.resolve(cmCreateRegistrationTag(null, emailAddr, city, country, postalCode));
    //     // }
    //     // else {
    //     //       Promise.resolve(true);
    //     // }
    //     Promise.resolve(true);
    // }

    /**
     * If a user's locale is US or CA, turn on google places autocomplete by default.
     * Otherwise turn it on on change of country dropdown, if selected country is US or CA
     * @param {string} selector - DOM element
     * @returns {Promise}
     */
    autoCompleteSetup(selector, model, session, store) {
        let selectedCountry;

        if(selector.hasClass('js-account-address-country-select')) {
            selectedCountry = selector.val().toLowerCase();
        } else {
            selectedCountry = store.core.userLocation.country_code.toLowerCase();
        }

        if (selectedCountry === 'us') {
            super.updateViewState('autoComplete', true);
            super.updateViewState('autoCompleteLocale', selectedCountry);
        } else {
            super.updateViewState('autoComplete', false);
        }
        return Promise.resolve(this);
    }

    updateTempAddressGroupType(selector, model, session, store) {
        const groupType = _.get(getInitialGroupType(store), 'data');

        if (groupType) {
            AddressModel.setTempAddressGroupType(groupType);
        }

        return Promise.resolve(this);
    }

    updatePxpPublicKey(selector, model, session, store) {
        const siteIndex = getSiteBySiteId(store);
        const pxpEnabled = _.get(store, `core.siteConfig.sites[${siteIndex}].pxpEnabled`);

        if (!pxpEnabled) {
            return Promise.resolve(this);
        }

        return new Promise((resolve, reject) => {
            Service.getPxpPublicKey()
                .then(response => {
                    if (_.get(response, 'data')) {
                        const pxpData = {
                            publicKey: atob(_.get(response, 'data.publicEncryptionKey.pem')),
                            encryptionId: _.get(response, 'data.encryptionId'),
                        };

                        AddressModel.setPxpPublicKey(pxpData);
                    }

                    return resolve(this);
                });
        });
    }

    /**
     * Initialize google places autocomplete on '#address1' input, and remove it if
     * selected country is not US or CA
     * @param {Object} controller - Address controller
     * @param {Object} model - Address model
     * @returns {Promise}
     */
    autoComplete(controller, model, store) {
        if (this.viewStates.autoComplete) {
            jQuery('form').attr('autocomplete', 'off');
            jQuery('input[name="hidden"]').attr('autocomplete', 'false');

            if (document.getElementById('address1')) {
                const input = document.getElementById('address1');

                jQuery(input).removeAttr('placeholder');

                const autocomplete = new google.maps.places.Autocomplete(input, {
                    types: ['address'],
                    componentRestrictions: {
                        country: this.viewStates.autoCompleteLocale,
                    },
                    fields: ['address_components'],
                });

                google.maps.event.addDomListener(input, 'keydown', function(e) {
                    if (e.keyCode == 13) {
                        e.preventDefault();
                    }
                });

                google.maps.event.addListener(autocomplete, 'place_changed', () => {
                    super.updateViewState('autoCompleteSelected', true);
                    const place = autocomplete.getPlace();
                    AddressModel.selectGooglePlace(place.address_components)
                        .then(model => {
                            super.updateViewState('autoCompleteSelected', true);
                            Events.removeAllEvents(this);
                            controller.render(store);
                        });
                });
            }
            model.gpAutocompleteOn = true;
        } else {
            if (model.gpAutocompleteOn) {
                // we need to unbind the autocomplete event from a few possible inputs
                let inputs = jQuery('.js-address-edit-form').find('input');
                for(let i = 0; i < inputs.length; i++) {
                    if(typeof inputs[i] !== 'undefined') {
                        google.maps.event.clearInstanceListeners(inputs[i]);
                        let input = jQuery(inputs[i]);
                        if(input.attr('autocomplete')) {
                            input.attr('placeholder', '');
                        }
                    }
                }

                model.gpAutocompleteOn = false;
            }
        }
        return Promise.resolve(this);
    }

    buildGPQuery(selector) {
        const $formInputs = jQuery(selector).parent().find('input:not(input[type="button"]), select');
        let tempAddress = [];
        $formInputs.each(function(index) {
            const $this = jQuery(this);
            const parts = $this.attr('name');
            let value;
            if ($this[0].type === 'checkbox') {
                value = $this[0].checked;
            } else {
                value = $this.val();
            }
            if (parts !== 'nickName' && parts !== 'address.phoneNumber' && parts !== 'save' && parts !== 'cancel') {
                tempAddress.push(value);
            }
        });
        // need to attach the tempaddress to the model, so it can be referenced as opposed to being binded
        return Promise.resolve({
            address: `${tempAddress[3]} ${tempAddress[4]} ${tempAddress[5]} ${tempAddress[6]} ${tempAddress[7]} ${tempAddress[0]}`,
            subStrings: tempAddress
        });
    }

    setTempGroupType(selector, model, session, store) {
        let editSelectedAddressId = jQuery(selector).attr('data-address-id');
        let selectedAddress;
        model.userAddresses.forEach(function(address, index) {
            if (address.id == editSelectedAddressId) {
                selectedAddress = address;
            }
        });

        const tempGroupType = getGroupTypeByCountry(store, selectedAddress.address.country);
        const tempAddress = {
            address: {
                groupType: tempGroupType
            }
        };

        $.extend(true, model.temp, tempAddress);
    }

    displayModal(predictions, status) {
        // compare the tempaddress substrings to the predictions substrings, if any set doesnt match show modal with predictions.details
        // else return the event controller
    }

    /**
     * A method that doesn't allow adding a credit card
     * if it's expired by disabling select options.
     * @returns {undefined}
     */
    creditCardExpiration(model, selector, modelProperty, session, serviceMethod, viewModel) {
        return new Promise((resolve, reject) => {
            const months = jQuery('.js-account-card-expiration-month-payments option');
            const years = jQuery('.js-account-card-expiration-year-payments');
            const date = new Date();
            const currentMonth = date.getMonth() + 1 < 10 ? 0 + date.getMonth() + 1 : date.getMonth() + 1;
            const currentYear = date.getFullYear();

            if (currentYear == years.val()) {
                months.each(function() {
                    const inputVal = parseInt(jQuery(this).val(), 10);
                    const monthAsInt = parseInt(currentMonth, 10);

                    if (inputVal < monthAsInt) {
                        jQuery(this).attr('disabled', true);
                    }
                });
            }

            if (currentYear != years.val()) {
                months.each(function() {
                    const inputVal = parseInt(jQuery(this).val(), 10);
                    const monthAsInt = parseInt(currentMonth, 10);

                    if (inputVal < monthAsInt) {
                        if (jQuery(this).is(':selected')) {
                            years.children().eq(1).attr('disabled', true);
                        }
                    } else {
                        if (jQuery(this).is(':selected')) {
                            years.children().eq(1).attr('disabled', false);
                            jQuery(months).attr('disabled', false);
                        }
                    }
                });
            }
            resolve(true);
        });
    }

    /**
     * Resets the AddressModel.errors object to clear out server side errors
     * @param {object} selector Element that triggered the event
     * @param {object} model    The current model
     * @param {string} session    The current user's auth session
     * @param {object} store    The current state of the redux store
     */
    resetServerErrors(selector, model, session, store) {
        model.errors = {};
        this.viewStates.showErrors = false;
    }
}

const AddressView = new AddressViewModel(ProfileModel);

export default AddressView;
